export default "__VITE_ASSET__BKe80L2l__"